<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div v-if="showReport && !loading" class="main">
    <div class="bottom-back">
      <div class="header" v-if="thirdSections">
        <div class="header-item">
          <h1 class="total-text big-title">
            {{ thirdSections[0].ratio.toFixed(0) }}%<span>总正确率</span>
          </h1>
          <h4>整节课训练情况</h4>
        </div>
        <div v-if="thirdSections[1]" class="header-item-1">
          <h1 class="total-text">{{ thirdSections[1].ratio.toFixed(0) }}%</h1>
          <h4>自主发音正确率</h4>
        </div>
        <div v-if="thirdSections[2]" class="header-item-1">
          <h1 class="total-text">{{ thirdSections[2].ratio.toFixed(0) }}%</h1>
          <h4>提示后发音正确率</h4>
        </div>
      </div>

      <div
        v-for="section in sections2"
        :key="section.one.title"
        v-if="section.one.items.length > 0"
        class="section-back"
      >
        <h4 class="sub-title">{{ section.one.title }}</h4>
        <div class="letter-rows">
          <div v-for="item in section.one.items" :key="item.word" class="item">
            <div class="letter-circle">{{ item.letter }}</div>
            <h5 v-for="a in item.accuracys" :key="a.title">
              {{ a.title }} ：{{ a.ratio.toFixed(0) }} %
            </h5>
          </div>
        </div>
        <div
          v-for="item in section.two.items"
          :key="item.letter"
          class="row-square row-sq-2"
        >
          <div class="col-titles-row">
            <div></div>
            <div><p>正确率</p></div>
            <div><p>自主正确率</p></div>
            <div><p>提示后正确率</p></div>
          </div>

          <div
            v-for="row in item.rows"
            :key="row.word"
            class="s-row col-titles-row"
          >
            <div class="word title-word">{{ row.word }}</div>
            <div class="q-row" v-for="ac in row.accuracys" :key="ac.title">
              <label>{{ ac.ratio.toFixed(0) }}%</label>
            </div>
          </div>
        </div>
      </div>

      <h4 class="sub-title">目标声母整体训练情况</h4>
      <div class="letter-rows">
        <div v-for="item in secondSections" :key="item" class="item">
          <div class="letter-circle">{{ item.letter }}</div>
          <h5 v-for="a in item.accuracys" :key="a.title">
            {{ a.title }} ：{{ a.ratio.toFixed(0) }} %
          </h5>
        </div>
      </div>

      <h4 class="sub-title">目标声母在不同目标词训练情况</h4>
      <div v-for="item in firstSections" :key="item.letter" class="row-square">
        <h1>{{ item.letter }}</h1>
        <div v-for="row in item.rows" :key="row.pinyin" class="s-row">
          <div class="word">{{ row.word }}</div>
          <div class="right">
            <div class="right-row" v-for="ac in row.accuracys" :key="ac.title">
              <div class="pro-back">
                <div
                  v-for="b in blocks"
                  :style="{
                    'background-color':
                      ac.ratio / 20 >= b ? '#279fb1' : '#d9d9d9',
                    'margin-right': b === 5 ? 0 : 2 + 'px',
                  }"
                  class="block-item"
                  :key="b"
                ></div>
              </div>
              <div class="ending">
                <label>{{ ac.ratio.toFixed(0) }}%</label>
                <label class="small-text">{{ ac.title }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="!loading" class="main">
    <h1 class="title-header">今日表现</h1>
    <div v-for="item in manifestations" :key="item.key" class="input-row">
      <label>{{ item.title }}</label>
      <select v-model="item.score">
        <option value="良好">良好</option>
        <option value="普通">普通</option>
        <option value="不佳">不佳</option>
      </select>
    </div>
    <div v-if="uploading" class="loading">
      <div class="loader"></div>
    </div>
    <button v-else @click="onUploadButton" class="star-button">提交</button>
  </div>
</template>
<script>
import { pinyin } from 'pinyin-pro';
import { portalUrl } from '../static/config';
import 'core-js/actual/array/group-by';

const _0orL = (r) => {
  if (r !== undefined && r !== null) {
    return r.length;
  }

  return 0;
};

export default {
  data() {
    return {
      firstSections: undefined,
      secondSections: undefined,
      thirdSections: undefined,
      blocks: [1, 2, 3, 4, 5],
      showReport: false,
      uploading: false,
      loading: false,
      sections2: [],
      manifestations: [
        {
          title: '警醒度',
          key: 'vigilance',
          score: '良好',
        },
        {
          title: '配合度',
          key: 'blendage',
          score: '良好',
        },
        {
          title: '注意力',
          key: 'attention',
          score: '良好',
        },
        {
          title: '情绪',
          key: 'emotions',
          score: '良好',
        },
        {
          title: '主动性',
          key: 'initiative',
          score: '良好',
        },
        {
          title: '互动性',
          key: 'initiative_loop',
          score: '良好',
        },
      ],
    };
  },

  mounted() {
    this.fetchTestDetail();
  },

  methods: {
    onUploadButton() {
      this.uploading = true;
      const testId = this.$route.params.test_id;
      const token = localStorage.getItem(`${testId}_token`);

      const manifestation = {};

      this.manifestations.forEach((m) => {
        manifestation[m.key] = m.score;
      });

      this.axios({
        url: `${portalUrl}swam/r/update`,
        headers: {
          token,
        },
        data: {
          test_id: testId,
          manifestation,
          status: 'Close',
        },
        method: 'POST',
      }).then((res) => {
        this.uploading = false;
        if (res.data.success) {
          this.showReport = true;
          this.loading = false;
        } else {
          this.$notify({
            group: 'foo',
            title: '提示',
            text: '请求失败，请稍后重试！',
          });
        }
      });
    },
    fetchTestDetail() {
      this.loading = true;
      const testId = this.$route.params.test_id;
      const token = localStorage.getItem(`${testId}_token`);
      this.axios({
        url: `${portalUrl}swam/t/info`,
        headers: {
          token,
        },
        params: {
          test_id: testId,
        },
        method: 'GET',
      }).then((res) => {
        if (res.data.success && res.data.data.manifestation) {
          this.showReport = true;
        }

        if (res.data.success) {
          const flows = res.data.data.learning_flows;
          this._reformatReportData(flows);
          this._reformatReportDataSections2(flows);
        }

        if (!res.data.success) {
          this.$notify({
            group: 'foo',
            title: '提示',
            text: '请求失败，请稍后重试！',
          });
        }

        this.loading = false;
      });
    },

    _reformatReportData(flows) {
      const _flows = flows.filter((f) => f.type === 0);
      const firstSections = [];
      _flows.forEach((f) => {
        const hasNo =
          f.actions.findIndex((a) => a.action_name === 'no-thumb') >= 0;

        const result = f.actions.groupBy((a) => a.action_name);
        let accuracys;
        if (hasNo) {
          accuracys = [
            {
              title: '总正确率',
              ratio:
                ((_0orL(result['big-thumb']) + _0orL(result['small-thumb'])) /
                  (_0orL(result['big-thumb']) +
                    _0orL(result['small-thumb']) +
                    _0orL(result['no-thumb']))) *
                100,
            },
            {
              title: '自主发音正确率',
              ratio:
                (_0orL(result['big-thumb']) /
                  (_0orL(result['big-thumb']) +
                    _0orL(result['small-thumb']) +
                    _0orL(result['no-thumb']))) *
                100,
            },
            {
              title: '提示后发音正确率',
              ratio:
                (_0orL(result['small-thumb']) /
                  (_0orL(result['big-thumb']) +
                    _0orL(result['small-thumb']) +
                    _0orL(result['no-thumb']))) *
                100,
            },
          ];
        } else {
          const ratio =
            (_0orL(result['big-thumb']) /
              (_0orL(result['big-thumb']) + _0orL(result['small-thumb']))) *
            100;

          if (!isNaN(ratio)) {
            accuracys = [
              {
                title: '正确率',
                ratio,
              },
            ];
          }
        }

        if (accuracys) {
          firstSections.push({
            letter: pinyin(f.word, { pattern: 'initial', type: 'array' })[0],
            pinyin: pinyin(f.word),
            word: f.word,
            accuracys,
          });
        }
      });

      const _gfs = firstSections || [];
      const groupedObj = _gfs.groupBy((f) => f.letter);

      const keys = Object.keys(groupedObj);

      this.firstSections = keys.map((f) => {
        return {
          letter: f,
          rows: groupedObj[f],
        };
      });

      this._reformatReportDataType0(flows);
    },

    _reformatReportDataType0(flows) {
      this.secondSections = this._reformatReportDataSection2(flows);

      console.log('---second', this.secondSections);

      let allActions = [];

      flows.forEach((f) => {
        allActions = [...allActions, ...f.actions];
      });

      const result = allActions.groupBy((a) => a.action_name);

      const hasNo = result['no-thumb'] && result['no-thumb'].length;

      let accuracys;
      if (hasNo) {
        accuracys = [
          {
            title: '总正确率',
            ratio:
              ((_0orL(result['big-thumb']) + _0orL(result['small-thumb'])) /
                (_0orL(result['big-thumb']) +
                  _0orL(result['small-thumb']) +
                  _0orL(result['no-thumb']))) *
              100,
          },
          {
            title: '自主发音正确率',
            ratio:
              (_0orL(result['big-thumb']) /
                (_0orL(result['big-thumb']) +
                  _0orL(result['small-thumb']) +
                  _0orL(result['no-thumb']))) *
              100,
          },
          {
            title: '提示后发音正确率',
            ratio:
              (_0orL(result['small-thumb']) /
                (_0orL(result['big-thumb']) +
                  _0orL(result['small-thumb']) +
                  _0orL(result['no-thumb']))) *
              100,
          },
        ];
      } else {
        accuracys = [
          {
            title: '正确率',
            ratio:
              (_0orL(result['big-thumb']) /
                (_0orL(result['big-thumb']) + _0orL(result['small-thumb']))) *
              100,
          },
        ];
      }

      this.thirdSections = accuracys;
    },

    _reformatReportDataSection2(flows) {
      flows = flows.filter((f) => f.type === 0);
      const mergedSections = [];

      flows.forEach((f) => {
        const fInitial = pinyin(f.word, {
          pattern: 'initial',
          type: 'array',
        })[0];
        const hasF = mergedSections.findIndex((m) => m.letter === fInitial);

        if (hasF >= 0) {
          const exitedOne = mergedSections[hasF];

          exitedOne.actions = [...exitedOne.actions, ...f.actions];

          mergedSections[hasF] = exitedOne;
        } else {
          mergedSections.push({
            letter: fInitial,
            actions: f.actions,
          });
        }
      });

      const secondSections = mergedSections.map((m) => {
        const result = m.actions.groupBy((a) => a.action_name);

        const hasNo = result['no-thumb'] && result['no-thumb'].length > 0;

        let accuracys;
        if (hasNo) {
          accuracys = [
            {
              title: '总正确率',
              ratio:
                ((_0orL(result['big-thumb']) + _0orL(result['small-thumb'])) /
                  (_0orL(result['big-thumb']) +
                    _0orL(result['small-thumb']) +
                    _0orL(result['no-thumb']))) *
                100,
            },
            {
              title: '自主发音正确率',
              ratio:
                (_0orL(result['big-thumb']) /
                  (_0orL(result['big-thumb']) +
                    _0orL(result['small-thumb']) +
                    _0orL(result['no-thumb']))) *
                100,
            },
            {
              title: '提示后发音正确率',
              ratio:
                (_0orL(result['small-thumb']) /
                  (_0orL(result['big-thumb']) +
                    _0orL(result['small-thumb']) +
                    _0orL(result['no-thumb']))) *
                100,
            },
          ];
        } else {
          accuracys = [
            {
              title: '正确率',
              ratio:
                (_0orL(result['big-thumb']) /
                  (_0orL(result['big-thumb']) + _0orL(['small-thumb']))) *
                100,
            },
          ];
        }

        return {
          letter: m.letter,
          accuracys,
        };
      });

      return secondSections || [];
    },

    _reformatReportDataSectionRight2(flows) {
      const mergedSections = [];

      flows.forEach((f) => {
        const hasF = mergedSections.findIndex((m) => m.letter === f.initial);

        if (hasF >= 0) {
          const exitedOne = mergedSections[hasF];

          exitedOne.actions = [...exitedOne.actions, ...f.actions];

          mergedSections[hasF] = exitedOne;
        } else {
          mergedSections.push({
            letter: f.initial,
            actions: f.actions,
          });
        }
      });

      const secondSections = mergedSections.map((m) => {
        const result = m.actions.groupBy((a) => a.action_name);

        const hasNo = result['no-thumb'] && result['no-thumb'].length > 0;

        let accuracys;
        if (hasNo) {
          accuracys = [
            {
              title: '总正确率',
              ratio:
                ((_0orL(result['big-thumb']) + _0orL(result['small-thumb'])) /
                  (_0orL(result['big-thumb']) +
                    _0orL(result['small-thumb']) +
                    _0orL(result['no-thumb']))) *
                100,
            },
            {
              title: '自主发音正确率',
              ratio:
                (_0orL(result['big-thumb']) /
                  (_0orL(result['big-thumb']) +
                    _0orL(result['small-thumb']) +
                    _0orL(result['no-thumb']))) *
                100,
            },
            {
              title: '提示后发音正确率',
              ratio:
                (_0orL(result['small-thumb']) /
                  (_0orL(result['big-thumb']) +
                    _0orL(result['small-thumb']) +
                    _0orL(result['no-thumb']))) *
                100,
            },
          ];
        } else {
          accuracys = [
            {
              title: '正确率',
              ratio:
                (_0orL(result['big-thumb']) /
                  (_0orL(result['big-thumb']) + _0orL(['small-thumb']))) *
                100,
            },
          ];
        }

        return {
          letter: m.letter,
          accuracys,
        };
      });

      return secondSections || [];
    },

    _reformatReportDataSections2(flows) {
      const sections2 = [];
      [
        '单韵母结合的训练情况',
        '单韵母结合声母的训练情况',
        '复韵母结合声母的训练情况',
      ].forEach((type, tIndex) => {
        const filteredFlows = flows.filter((f) => f.type === tIndex + 1);

        const obj = {};

        obj.one = {
          items: this._reformatReportDataSectionRight2(filteredFlows),
          title: type,
        };

        obj.two = {
          items: this._reformatReportDataSectionRight3(filteredFlows),
          title: type,
        };

        sections2.push(obj);
      });

      this.sections2 = sections2;
    },

    _reformatReportDataSectionRight3(flows) {
      const firstSections = [];
      flows.forEach((f) => {
        const hasNo =
          f.actions.findIndex((a) => a.action_name === 'no-thumb') >= 0;

        const result = f.actions.groupBy((a) => a.action_name);
        let accuracys;
        if (hasNo) {
          accuracys = [
            {
              title: '总正确率',
              ratio:
                ((_0orL(result['big-thumb']) + _0orL(result['small-thumb'])) /
                  (_0orL(result['big-thumb']) +
                    _0orL(result['small-thumb']) +
                    _0orL(result['no-thumb']))) *
                100,
            },
            {
              title: '自主发音正确率',
              ratio:
                (_0orL(result['big-thumb']) /
                  (_0orL(result['big-thumb']) +
                    _0orL(result['small-thumb']) +
                    _0orL(result['no-thumb']))) *
                100,
            },
            {
              title: '提示后发音正确率',
              ratio:
                (_0orL(result['small-thumb']) /
                  (_0orL(result['big-thumb']) +
                    _0orL(result['small-thumb']) +
                    _0orL(result['no-thumb']))) *
                100,
            },
          ];
        } else {
          const ratio =
            (_0orL(result['big-thumb']) /
              (_0orL(result['big-thumb']) + _0orL(result['small-thumb']))) *
            100;

          if (!isNaN(ratio)) {
            accuracys = [
              {
                title: '正确率',
                ratio,
              },
            ];
          }
        }

        if (accuracys) {
          firstSections.push({
            letter: f.initial,
            word: f.word,
            accuracys,
          });
        }
      });

      const _gfs = firstSections || [];
      const groupedObj = _gfs.groupBy((f) => f.letter);

      const keys = Object.keys(groupedObj);

      return keys.map((f) => {
        return {
          letter: f,
          rows: groupedObj[f],
        };
      });
    },
  },
};
</script>

<style scoped>
.row-square > .s-row {
  display: flex;
  flex-direction: row;
  margin-top: 20px;
}

.title-word {
  width: 25% !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.col-titles-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.col-titles-row > div {
  width: 25%;
  font-size: 12px;
}

.q-row {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #279fb1;
  color: white;
  font-weight: bold;
}

.row-square > .s-row > .word {
  width: 72px;
  height: 25px;
  background-color: #f0f0f0;
}

.row-square {
  padding: 20px;
  width: calc(100vw - 40px);
  box-sizing: border-box;
}

.row-square > .s-row > .right {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-left: 10px;
  box-sizing: border-box;
  margin-top: -10px;
}

.row-square > .s-row > .right > .right-row > .pro-back {
  height: 50px;
  background-color: transparent;
  border-radius: 25px;
  position: relative;
  margin-bottom: 10px;
  display: flex;
  overflow: hidden;
  flex: 1;
}

.main {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(to right, #ffe0d9, #a4e0e9);
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: scroll;
}

.bottom-back {
  background-color: #e7fcff;
  min-height: auto;
  margin-top: 160px;
  box-sizing: border-box;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
}

.header {
  background-color: white;
  width: 100vw - 30px;
  margin: -100px 15px 0 15px;
  height: 126px;
  box-sizing: border-box;
  z-index: 100;
  border-radius: 20px;
  box-shadow: 5px -5px #279fb1;
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-end;
}

.header > .total-text {
  font-size: 35px;
  color: #333;
  font-weight: bolder;
  text-align: left;
  margin: 0;
  padding: 0;
}

.header > .header-item > .total-text > span {
  font-size: 15px;
  font-weight: normal;
}

.header-item {
  display: inline-flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.header-item-1 > .total-text {
  font-size: 24px;
}

.header-item-1 > h4 {
  font-size: 10px;
  font-weight: normal;
}

.big-title {
  font-size: 40px;
  font-weight: bold;
}

h1,
h4,
h5 {
  padding: 0;
  margin: 0;
  z-index: 100;
}

.sub-title {
  margin-top: 20px;
}

.letter-rows {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 20px;
}

.letter-rows > .item {
  width: calc((100vw - 40px) / 2);
  height: 144px;
  background-color: #e7fcff;
  z-index: 100;
  margin-left: 10px;
  margin-bottom: 10px;
  border-radius: 20px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.letter-rows > .item > h5 {
  font-size: 0.8em;
  font-weight: bold;
}

.letter-circle {
  background-color: #279fb1;
  color: white;
  width: 48px;
  height: 48px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 6px;
}

.row-square {
  width: calc(100vw - 20px);
  background-color: white;
  z-index: 100;
  margin-left: 10px;
  margin-top: 20px;
  border-radius: 20px;
}

.top-back {
  position: fixed;
  background-color: transparent;
  border: none;
  z-index: 10000;
}

.top-back > img {
  width: 77px;
  height: 44px;
}

.title-header {
  margin-top: 30px;
  margin-bottom: 10px;
}

.input-row {
  width: calc(100vw - 30px);
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  align-items: center;
  margin-bottom: 20px;
  margin-left: 15px;
}

.input-row > label {
  width: 90px;
  font-size: 20px;
  font-weight: bold;
}

.input-row > select {
  height: 65px;
  flex: 1;
  border: none;
  border-radius: 32.5px;
  background-color: white;
  padding: 20px;
  box-sizing: border-box;
  font-size: 20px;
  font-weight: bold;
  color: #7b7b7b;
  border-right: 16px solid transparent;
}

.star-button {
  height: 64px;
  width: calc(100vw - 80px);
  border-radius: 32px;
  background-color: #279fb1;
  border: none;
  font-size: 22px;
  font-weight: bolder;
  color: white;
  margin-left: auto;
  margin-right: auto;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  overflow: hidden;
  margin-top: 40px;
}

.loader {
  width: 30px;
  aspect-ratio: 1;
  display: grid;
  border-radius: 50%;
  background: linear-gradient(
        0deg,
        rgb(0 0 0/50%) 30%,
        #0000 0 70%,
        rgb(0 0 0/100%) 0
      )
      50%/8% 100%,
    linear-gradient(90deg, rgb(0 0 0/25%) 30%, #0000 0 70%, rgb(0 0 0/75%) 0)
      50%/100% 8%;
  background-repeat: no-repeat;
  animation: l23 1s infinite steps(12);
}
.loader::before,
.loader::after {
  content: '';
  grid-area: 1/1;
  border-radius: 50%;
  background: inherit;
  opacity: 0.915;
  transform: rotate(30deg);
}
.loader::after {
  opacity: 0.83;
  transform: rotate(60deg);
}
@keyframes l23 {
  100% {
    transform: rotate(1turn);
  }
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  height: 64px;
  width: calc(100vw - 80px);
  margin-top: 40px;
}

.block-item {
  background-color: #279fb1;
  width: 20%;
  height: 60px;
  margin-right: 2px;
}

.ending {
  width: 50px;
  display: flex;
  flex-direction: column;
  margin-left: 2px;
}

.right-row {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
}

.small-text {
  font-size: 7px;
}

.section-back {
  background-color: rgba(255, 255, 255, 0.5);
  padding: 10px 0;
  margin-top: 15px;
  border-radius: 10px;
  padding-bottom: 20px;
}

.row-sq-2 {
  margin-top: 4px;
}
</style>
